import {
  makeStyles,
  Step,
  StepConnector,
  StepLabel,
  Stepper
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import React, { FC } from 'react';
import { LayoutVariant } from '../../../Core/CommonTypes';
import { QontoStepIcon } from './QontoStepIcon';

const useStyles = makeStyles(() => ({
  stepper: {},
  mobileStepper: {
    paddingLeft: 0,
    paddingRight: 0
  }
}));

const QontoConnector = withStyles(() => ({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)'
  },
  active: {
    '& $line': {
      borderColor: '#00796b'
    }
  },
  completed: {
    '& $line': {
      borderColor: '#00796b'
    }
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1
  }
}))(StepConnector);

interface SubmitStepsProps {
  activeStep?: number;
  steps: string[];
  variant?: LayoutVariant;
}

const SubmitSteps: FC<SubmitStepsProps> = ({ activeStep, steps, variant }) => {
  const classes = useStyles();
  return (
    <Stepper
      alternativeLabel
      activeStep={activeStep}
      classes={{
        root:
          variant === LayoutVariant.mobile
            ? classes.mobileStepper
            : classes.stepper
      }}
      connector={<QontoConnector />}
    >
      {steps.length > 0 &&
        steps.map(label => (
          <Step key={label}>
            <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
          </Step>
        ))}
    </Stepper>
  );
};

export default SubmitSteps;
